angular.module('signalview.quickAnalytics', ['chartdisplay']);
